import React, { useEffect } from 'react'

import Alerts from 'pages/shared/AlertsTooltip/Alerts'

import { Alert, DeviceConnectionState } from 'types/Alert'

type Props = {
  screenSize: string
  allAlerts: Array<Alert>
  displayAlertIds: string | null
  deviceConnectionState: Array<DeviceConnectionState> | null
  setDisplayAlertIds: React.Dispatch<React.SetStateAction<string | null>>
  isPortrait: boolean
}

const TooltipContent = ({ allAlerts, deviceConnectionState, screenSize, displayAlertIds, setDisplayAlertIds, isPortrait }: Props) => {
  useEffect(() => {
    setDisplayAlertIds(displayAlertIds)
  }, [displayAlertIds, setDisplayAlertIds])

  if ((screenSize === 'sm' || screenSize === 'xs') && !isPortrait) {
    return null
  }

  return (
    <Alerts
      deviceConnectionState={deviceConnectionState}
      alerts={allAlerts}
      displayAlertIds={displayAlertIds}
    />
  )
}

export default TooltipContent
